import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation } from "@tanstack/react-query";
import { OPEN_POSITION_RESOURCE } from "./use-open-position-search.query";

export const OPEN_POSITION_SYNC_API_PATH = `/v1/${OPEN_POSITION_RESOURCE}/{openPositionUuid}/sync` as const;

export const getOpenPositionSyncPath = (openPositionUuid: string) =>
  `/v1/${OPEN_POSITION_RESOURCE}/${openPositionUuid}/sync`;

export type OpenPositionSyncResponse =
  paths[typeof OPEN_POSITION_SYNC_API_PATH]["post"]["responses"][202]["content"]["application/json"];

export function useOpenPositionSyncMutation() {
  return useMutation<OpenPositionSyncResponse, Error, { openPositionUuid: string }>({
    mutationFn: async ({ openPositionUuid }) => {
      const response = await alphartisApiAxios.post<OpenPositionSyncResponse>(
        getOpenPositionSyncPath(openPositionUuid),
      );

      return response.data;
    },
  });
}
